module.exports = __webpack_public_path__ + "img/7_180.88a0eb4c.png";